import {
  jb_headline_with_text_css_default
} from "./chunk.Z6VYBXXH.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-headline-with-text/jb-headline-with-text.ts
var JbHeadlineWithText = class extends i {
  _renderHeadline(headline) {
    return b`<jb-heading
      class="${e({ headline: true, "with-border": !!this.withBorder })}"
      variant="heading-md"
      >${headline}</jb-heading
    >`;
  }
  _renderSubline(subline) {
    return b`<jb-heading
      class="subline"
      offset=${this.headline ? 1 : 0}
      >${subline}</jb-heading
    >`;
  }
  render() {
    return b`
      ${this.headline ? this._renderHeadline(this.headline) : A}
      ${this.subtitle ? this._renderSubline(this.subtitle) : A}
      <jb-heading-context offset=${this.headline || this.subtitle ? 1 : 0}>
        <slot></slot>
      </jb-heading-context>
    `;
  }
};
JbHeadlineWithText.styles = [reset_css_default, jb_headline_with_text_css_default];
__decorateClass([
  n({ reflect: true })
], JbHeadlineWithText.prototype, "headline", 2);
__decorateClass([
  n()
], JbHeadlineWithText.prototype, "subtitle", 2);
__decorateClass([
  n({ type: Boolean })
], JbHeadlineWithText.prototype, "withBorder", 2);
JbHeadlineWithText = __decorateClass([
  customElement("jb-headline-with-text")
], JbHeadlineWithText);

export {
  JbHeadlineWithText
};
